"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var wrappers = {};
var wrapFunction = function wrapFunction(fn, type, source) {
    var t = type || "default";
    return function () {
        var callee = t in wrappers ? wrappers[t](fn, source) : fn;
        return callee.apply(this, arguments);
    };
};
wrapFunction.setWrapper = function (fn) {
    var type = arguments.length <= 1 || arguments[1] === undefined
        ? "default"
        : arguments[1];
    wrappers[type] = fn;
};
exports.default = wrapFunction;
